var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 325.5 223.6)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-255.95, -256.3)",
    d: "M 443.6 387.1 L 312.4 255.4 l 131.5 -130 c 5.4 -5.4 5.4 -14.2 0 -19.6 l -37.4 -37.6 c -2.6 -2.6 -6.1 -4 -9.8 -4 c -3.7 0 -7.2 1.5 -9.8 4 L 256 197.8 L 124.9 68.3 c -2.6 -2.6 -6.1 -4 -9.8 -4 c -3.7 0 -7.2 1.5 -9.8 4 L 68 105.9 c -5.4 5.4 -5.4 14.2 0 19.6 l 131.5 130 L 68.4 387.1 c -2.6 2.6 -4.1 6.1 -4.1 9.8 c 0 3.7 1.4 7.2 4.1 9.8 l 37.4 37.6 c 2.7 2.7 6.2 4.1 9.8 4.1 c 3.5 0 7.1 -1.3 9.8 -4.1 L 256 313.1 l 130.7 131.1 c 2.7 2.7 6.2 4.1 9.8 4.1 c 3.5 0 7.1 -1.3 9.8 -4.1 l 37.4 -37.6 c 2.6 -2.6 4.1 -6.1 4.1 -9.8 C 447.7 393.2 446.2 389.7 443.6 387.1 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.e385dfadfce7454e3d4030c26657f53e.svg";
export { ForwardRef as ReactComponent };